/**
 * Wordpress likes to wrap `p` elements in span with an inline
 * font-size, so let's use this func to clean up the content.
 * @param [post] post
 */
export const sanitizePost = (post) => {
  return post.map((p) => {
    p.content.rendered = p.content.rendered.replace(/font-size: 12pt;/gi, '')
    return p
  })
}
